module.exports = __webpack_public_path__ + "static/media/ic_close_gray.5f9f6a83.svg";